import english from "../assets/images/flags/en.png"
import sinhala from "../assets/images/flags/si.png"
import tamil from "../assets/images/flags/ta.png"

const languages = {
  si: {
    label: "Sinhala",
    flag: sinhala,
  },
  ta: {
    label: "Tamil",
    flag: tamil,
  },
  en: {
    label: "English",
    flag: english,
  },
}

export default languages
